"use strict";

const listEvenOdd = document.querySelector("[data-js='list-even-odd']");

if (listEvenOdd) {
	window.addEventListener("load", listEvenOddPosition);
	window.addEventListener("resize", listEvenOddPosition);

	function listEvenOddPosition() {
		let heightInit = listEvenOdd.children[0].offsetHeight;
		let heightInfoMob = listEvenOdd.children[1].offsetHeight;
		if (window.innerWidth < 991) {
			let i;
			for (i = 0; i < listEvenOdd.children.length; i++) {
				listEvenOdd.children[i].style.marginTop = "-" + (
				heightInit - heightInfoMob - 20) + "px";
			}

			let specialCard = document.getElementById("last-class");
			specialCard.setAttribute("style", "margin-top: -" + (
			heightInit - heightInfoMob - 20) + "px !important");
		} else {
			let i;
			for (i = 0; i < listEvenOdd.children.length; i++) {
				listEvenOdd.children[i].style.marginTop = "";
			}
		}
	};
}